import { Steps } from "antd";
import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import {
  SendOutlined,
  UserOutlined,
  SolutionOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";

import colors from "../../../../colors";
import CustomIcon from "../../../app/generic/customIcon";

import "./index.css";

export const MIN = 0,
  MIDDLE = 1,
  MAX = 2;

const getColor = (current, max, error) =>
  error || current === max
    ? colors.RED
    : current < max
    ? colors.GRAY
    : colors.YELLOW;

const getState = (current, max, error) =>
  error
    ? "error"
    : current === max
    ? "process"
    : current < max
    ? "wait"
    : "finish";

const FormSteps = ({
  current,
  formHasError,
  onSetCurrent,
  sendHasError,
  productsHasError,
  consentsHasError,
}) => {
  const intl = useIntl();

  const steps = useMemo(
    () => [
      {
        title: intl.formatMessage({
          id: "registration.steps.form",
          defaultMessage: "Údaje",
        }),
        status: getState(current, MIN, formHasError || productsHasError),
        icon: (
          <CustomIcon
            color={getColor(current, MIN, formHasError || productsHasError)}
            icon={
              formHasError || productsHasError
                ? ExclamationCircleFilled
                : UserOutlined
            }
          />
        ),
      },
      {
        title: intl.formatMessage({
          id: "registration.steps.consents",
          defaultMessage: "Souhlasy",
        }),
        status: getState(current, MIDDLE, consentsHasError),
        icon: (
          <CustomIcon
            color={getColor(current, MIDDLE, consentsHasError)}
            icon={consentsHasError ? ExclamationCircleFilled : SolutionOutlined}
          />
        ),
      },
      {
        title: intl.formatMessage({
          id: "registration.steps.end",
          defaultMessage: "Odeslání",
        }),
        status: getState(current, MAX, sendHasError),
        icon: (
          <CustomIcon
            color={getColor(current, MAX, sendHasError)}
            icon={sendHasError ? ExclamationCircleFilled : SendOutlined}
          />
        ),
      },
    ],
    [
      intl,
      current,
      sendHasError,
      formHasError,
      productsHasError,
      consentsHasError,
    ]
  );

  const handleChange = useCallback(
    (value) => {
      onSetCurrent(value);
    },
    [onSetCurrent]
  );

  return (
    <Steps
      items={steps}
      current={current}
      onChange={handleChange}
      className="form-steps-margin"
    />
  );
};

export default FormSteps;
